import { Form, ModalProps, FormProps, Modal, Select, useSelect } from '@pankod/refine-antd'
import { ITestTrack } from 'interfaces'

type EditProductTracksProps = {
  modalProps: ModalProps
  formProps: FormProps
  close?: any
  record: any
}

export const EditProductTracks: React.FC<EditProductTracksProps> = ({ modalProps, formProps, close, record }) => {
  const { selectProps: testTrackSelectProps } = useSelect<ITestTrack>({
    resource: 'test_tracks',
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    filters: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    fetchSize: 1000,
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
    queryOptions: { enabled: !!modalProps?.visible },
  })

  const onFinish = (values: any) => {
    close()
    return (
      formProps.onFinish &&
      formProps.onFinish({
        test_track_ids: values?.test_track_ids,
      })
    )
  }

  return (
    <Modal {...modalProps} title="Edit Tracks" afterClose={() => formProps?.form?.resetFields()}>
      <Form {...formProps} layout="vertical" onFinish={values => onFinish(values)}>
        <Form.Item label="Subject Track" name="test_track_ids" rules={[{ required: true }]}>
          <Select {...testTrackSelectProps} mode="multiple" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
